import SmoothScroll from 'smooth-scroll';

function initScrollAnimation (container) {
  let scrolling = false;
  let currentScreen = 0;
  const spaceElement = document.querySelector('.app-template__space');
  const SCROLL_START_CAR = 15;
  const SCROLL_SHOW_1_IMAGE = 35;
  const SCROLL_HIDE_1_IMAGE = 55;
  const SCROLL_SHOW_2_IMAGE = 65;
  const SCROLL_HIDE_2_IMAGE = 75;
  const SCROLL_SHOW_3_IMAGE = 80;
  const SCROLL_HIDE_3_IMAGE = 90;
  const SCROLL_SHOW_FAQ = 95;

  function initMousewheel () {
    const scroll = new SmoothScroll('body', {
      speed: 1500,
      emitEvents: true,
      speedAsDuration: true,
      easing: 'Linear',
    });

    let touchstartY = 0;
    let touchendY = 0;

    document.addEventListener('touchstart', function (event) {
      touchstartY = event.changedTouches[0].screenY;
    }, false);

    document.addEventListener('touchend', function (event) {
      touchendY = event.changedTouches[0].screenY;
      if (event.target.classList.contains('app-template__p')) {
        return false;
      }
      if (scrolling) {
        return false;
      }
      if (touchendY <= touchstartY) {
        scrollEvent(1);
      } else if (touchendY >= touchstartY) {
        scrollEvent(-1);
      }
    }, false);

    if ('onwheel' in document) {
      document.addEventListener('wheel', onWheel);
    } else if ('onmousewheel' in document) {
      document.addEventListener('mousewheel', onWheel);
    } else {
      document.addEventListener('MozMousePixelScroll', onWheel);
    }

    function onWheel (e) {
      e = e || window.event;
      const delta = e.deltaY || e.detail || e.wheelDelta;
      scrollEvent(delta);
    }

    function scrollEvent (delta) {
      if (scrolling) {
        return false;
      }

      const templateHeight = spaceElement.offsetHeight;
      let nextPosition = 0;
      let prevPosition = 0;

      switch (currentScreen) {
        case 0:
          nextPosition = templateHeight * (SCROLL_SHOW_1_IMAGE + 2) / 100;
          prevPosition = 0;
          break;
        case 1:
          nextPosition = templateHeight * (SCROLL_SHOW_2_IMAGE + 2) / 100;
          prevPosition = 0;
          break;
        case 2:
          nextPosition = templateHeight * (SCROLL_SHOW_3_IMAGE + 2) / 100;
          prevPosition = templateHeight * (SCROLL_SHOW_1_IMAGE + 1) / 100;
          break;
        case 3:
          nextPosition = templateHeight * (SCROLL_SHOW_FAQ + 2) / 100;
          prevPosition = templateHeight * (SCROLL_SHOW_2_IMAGE + 1) / 100;
          break;
        default:
          return false;
      }

      if (delta > 0) {
        scroll.animateScroll(nextPosition);
      } else {
        scroll.animateScroll(prevPosition);
      }
    }

    const logScrollEvent = function (event) {
      if (event.type === 'scrollStop') {
        scrolling = false;
      }
      if (event.type === 'scrollCancel') {
        scrolling = false;
      }
      if (event.type === 'scrollStart') {
        scrolling = true;
      }
    };

    document.addEventListener('scrollStart', logScrollEvent, false);
    document.addEventListener('scrollStop', logScrollEvent, false);
    document.addEventListener('scrollCancel', logScrollEvent, false);
  }

  const carElement = document.getElementById('lottie');
  const arrowElement = document.getElementById('scroll-arrow');
  const deviceElement = document.getElementById('app-template-device');
  const image1 = document.getElementById('app-template-image-1');
  const image2 = document.getElementById('app-template-image-2');
  const image3 = document.getElementById('app-template-image-3');
  const faqTitleElement = document.getElementById('faq-title');
  const navigationElements = document.querySelectorAll('.app-template__navigation div');

  function updateState (event) {
    const templateHeight = spaceElement.offsetHeight;
    const position = window.scrollY;
    const positionInPercents = 100 / templateHeight * position;

    const moveDelta = 2;
    if (
      (positionInPercents <= SCROLL_SHOW_3_IMAGE + moveDelta && positionInPercents >= SCROLL_SHOW_3_IMAGE - moveDelta) ||
      (positionInPercents <= SCROLL_SHOW_2_IMAGE + moveDelta && positionInPercents >= SCROLL_SHOW_2_IMAGE - moveDelta) ||
      (positionInPercents <= SCROLL_SHOW_1_IMAGE + moveDelta && positionInPercents >= SCROLL_START_CAR - moveDelta) ||
      (positionInPercents >= SCROLL_HIDE_3_IMAGE + moveDelta)
    ) {
      container.classList.add('pause-bg');
    } else {
      container.classList.remove('pause-bg');
    }

    if (positionInPercents >= SCROLL_HIDE_3_IMAGE + 3) {
      currentScreen = 4;
      deviceElement.classList.add('app-template__hidden');
    } else if (positionInPercents <= SCROLL_SHOW_3_IMAGE + 3 && positionInPercents >= SCROLL_SHOW_3_IMAGE - 3) {
      currentScreen = 3;
    } else if (positionInPercents <= SCROLL_SHOW_2_IMAGE + 3 && positionInPercents >= SCROLL_SHOW_2_IMAGE - 3) {
      currentScreen = 2;
    } else if (positionInPercents <= SCROLL_SHOW_1_IMAGE + 3 && positionInPercents >= SCROLL_SHOW_1_IMAGE - 3) {
      currentScreen = 1;
    } else if (positionInPercents <= SCROLL_SHOW_1_IMAGE - 3) {
      currentScreen = 0;
    }

    if (positionInPercents < SCROLL_HIDE_3_IMAGE) {
      deviceElement.classList.remove('app-template__hidden');
    }

    navigationElements.forEach((element, index) => {
      if (index === currentScreen) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
    });

    // car
    if (positionInPercents > SCROLL_START_CAR && positionInPercents < SCROLL_HIDE_1_IMAGE) {
      carElement.style.display = 'block';
      const carPosition = parseFloat((positionInPercents - SCROLL_START_CAR) * 4.8).toFixed(2);
      carElement.style.transform = `translateX(${carPosition}vh)`;
    }
    if (positionInPercents < SCROLL_START_CAR) {
      carElement.style.transform = 'translateX(0)';
    }
    if (positionInPercents > SCROLL_SHOW_1_IMAGE) {
      carElement.style.display = 'none';
    }

    // arrow
    if (positionInPercents > SCROLL_START_CAR) {
      arrowElement.classList.add('app-template__hidden');
    } else {
      arrowElement.classList.remove('app-template__hidden');
    }

    if (positionInPercents > SCROLL_SHOW_1_IMAGE + 5) {
      deviceElement.classList.add('app-template__device--bg');
    } else {
      deviceElement.classList.remove('app-template__device--bg');
    }

    // images
    if (positionInPercents > SCROLL_SHOW_1_IMAGE && positionInPercents < SCROLL_HIDE_1_IMAGE) {
      image1.classList.add('app-template__show');
    } else {
      image1.classList.remove('app-template__show');
    }

    if (positionInPercents > SCROLL_SHOW_2_IMAGE && positionInPercents < SCROLL_HIDE_2_IMAGE) {
      image2.classList.add('app-template__show');
    } else {
      image2.classList.remove('app-template__show');
    }

    if (positionInPercents > SCROLL_SHOW_3_IMAGE && positionInPercents < SCROLL_HIDE_3_IMAGE) {
      image3.classList.add('app-template__show');
    } else {
      image3.classList.remove('app-template__show');
    }

    if (positionInPercents > SCROLL_SHOW_FAQ) {
      faqTitleElement.classList.add('app-template__show');
    } else {
      faqTitleElement.classList.remove('app-template__show');
    }
  }

  // commit height for mobile devices - blink bug with bar
  function setWrapHeight () {
    const wrapElement = container.querySelector('.app-template__wrap');
    wrapElement.style.height = '55%';
    setTimeout(() => {
      wrapElement.style.height = wrapElement.offsetHeight + 'px';
      updateState();
    }, 100);
  }

  window.addEventListener('orientationchange', setWrapHeight, false);
  setWrapHeight();

  window.addEventListener('scroll', updateState);
  updateState();

  initMousewheel();
}

export default function () {
  document.querySelectorAll('.app-template').forEach(initScrollAnimation);
}
